import { ChangeDetectorRef, Component, OnInit, AfterViewInit } from '@angular/core';
import { PaykuCreateFormComponent } from '../../payku/payku-create-form/payku-create-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaykuService } from 'src/app/services/payku.service';
import { CreateClientForm } from 'src/app/models/Payku/CreateClientForm';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { Response } from 'src/app/shared/models/Response';
import { TourService, CallbacksWizardTour } from 'src/app/services/tour-tutorial.service';
import { ConfiguracionesTour } from 'src/app/shared/models/tour-tutorial-configurations';
import { AuthService } from 'src/app/modules/auth';


@Component({
  selector: 'app-payku-create-button',
  templateUrl: './payku-create-button.component.html',
  styleUrls: ['./payku-create-button.component.scss']
})
export class PaykuCreateCardComponent implements OnInit {
  loading = false;
  isAdmin = false;
  paykuEnabled = false;
  hasActiveAccount = false;
  private cuentaVerificada = false; // Bandera para saber si ya verificamos la cuenta
  private modalRef: any;

  constructor(
    private modalService: NgbModal,
    private paykuService: PaykuService,
    private ref: ChangeDetectorRef,
    private utilities: UtilitiesService,
    private tokenService: TokenStorageService,
    private tourService: TourService,
    private authService: AuthService
  ){}

  async ngOnInit(): Promise<void> {
    try {
      await this.checkActiveAccount();
      this.cuentaVerificada = true;
      //this.verificarYEjecutarTour();
    } catch (error) {
      console.error('Error chequeando estado Payku', error);
      this.paykuEnabled = false;
      this.hasActiveAccount = false;
      this.cuentaVerificada = true;
    }
  }

  private async checkActiveAccount(): Promise<void> {
    const emisorId = this.tokenService.getCompany();
    if (!emisorId) {
      this.hasActiveAccount = false;
      return;
    }

    try {
      const response = await this.paykuService.hasActiveAccount(emisorId).toPromise();
      this.hasActiveAccount = !!response?.data;
    } catch (error) {
      this.hasActiveAccount = false;
    }
  }
  /*ngAfterViewInit(): void {
    this.verificarYEjecutarTour();
  }

  private verificarYEjecutarTour(): void {
    if (this.cuentaVerificada && !this.hasActiveAccount) {
      this.esperarBotonYIniciarTour();
    } else if (this.cuentaVerificada && this.hasActiveAccount) {
      console.log('Tour cancelado');
    }
  }

  private esperarBotonYIniciarTour(intentos: number = 0): void {
    if (this.hasActiveAccount) {
      return;
    }

    const boton = document.querySelector('#paykuCreateBtn');
    if (boton) {
      this.tourService.iniciarTour(
        ConfiguracionesTour.PAYKU,
        {
          abrirModal: () => {
            (boton as HTMLElement).click();
          }
        }
      );
      return;
    }
    
    if (intentos < 5) {
      setTimeout(() => this.esperarBotonYIniciarTour(intentos + 1), 100);
    } else {
      console.log('Tour cancelado');
    }
  }*/

  onCreate(): void {
    this.loading = true;
    this.ref.detectChanges();
    
    const usuarioId = this.tokenService.getUser().id;

    forkJoin({
      bancos: this.paykuService.getBancos(),
      datosBancarios: this.paykuService.getDatosBancarios(usuarioId)
    }).subscribe({
      next: (response) => {
        this.loading = false;
        this.ref.detectChanges();
        
        this.modalRef = this.modalService.open(PaykuCreateFormComponent, {
          size: 'lg',
          centered: true,
          backdrop: 'static'
        });
        
        this.modalRef.componentInstance.bancos = response.bancos;
        this.modalRef.componentInstance.datosBancarios = response.datosBancarios.data || [];
        this.modalRef.componentInstance.iniciarTour = true; 
        this.modalRef.componentInstance.onCreateClient = (clientData: CreateClientForm) => {
          this.createClient(clientData, this.modalRef);
        };
        this.modalRef.result.catch(() => {});
      },
      error: (err) => {
        this.loading = false;
        this.ref.detectChanges();
        console.error('Error cargando datos:', err);
        Swal.fire({
          title: "Error",
          text: "No fue posible cargar la información necesaria. Por favor, intenta nuevamente.",
          icon: "error",
        });
      }
    });
  }

  createClient(clientData: CreateClientForm, modalRef: any): void {
    this.loading = true;
    this.ref.detectChanges();
    
    this.paykuService.createClient(clientData).subscribe({
      next: (response: Response<any>) => {
        this.loading = false;
        this.ref.detectChanges();
        
        // Actualizar el estado: ahora tiene cuenta activa
        this.hasActiveAccount = true;
        
        const msg = response.message || 'Tu cuenta Payku ha sido creada exitosamente.';
        Swal.fire({
          title: "¡Cuenta creada!",
          text: msg+" Debe iniciar sesión nuevamente para reflejar los cambios.",
          icon: "success",
        }).then(() => {
          this.authService.logout().subscribe({
            next: () => {
              modalRef.close('success');
              window.location.reload();
            },
            error: () => {
              modalRef.close('success');
              window.location.reload();
            }
          });
        });
      },
      error: (err) => {
        this.loading = false;
        this.ref.detectChanges();
        const details = this.utilities.setErrorMessageFromArray(err?.error);
        Swal.fire({
          title: "Error",
          text: `No fue posible crear la cuenta Payku. Intenta nuevamente. ${details || ''}`.trim(),
          icon: "error",
        });
      }
    });
  }
}